import React from 'react';

const IconSortDesc = (
    <svg viewBox="0 0 19 15">
        <path d="M9.5 13L17 1H2z" fill="currentColor" stroke="currentColor" strokeWidth="2" fillRule="evenodd" />
    </svg>
);

export default IconSortDesc;
